// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import OverflowMenuPresentationPropsDefault from "@conklin/MobiusOverrides/OverflowMenu/presentationProps";
import { xBaseTheme } from "@conklin/XDL/types";
import { color, styledScrollbar } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            color: "common.ui9",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                background-color: transparent;
                border-color: transparent;
                && {
                    width: 33px;
                    height: 33px;
                }
                & > ${IconWrapper} {
                    color: ${color("common.ui9")};
                    top: 0;
                }
                &:hover,
                &:focus {
                    &&& {
                        background-color: transparent;
                        border-color: transparent;
                        > ${IconWrapper} {
                            color: ${color("common.ui10")};
                        }
                    }
                }
            `,
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
                @media print {
                    display: none;
                }
            `,
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(4)}
                transition: none;
            `,
            menuItem: css`
                /* to override safar (color:-apple-system-blue) browser native css on all buttons */
                color: ${color("text")};
                padding: 8px 12px;

                &:disabled {
                    color: ${color("text", 0.3)};
                }

                &:hover,
                &:active,
                &:focus {
                    background: ${color("common.ui9")};
                    color: ${color("common.white")};
                    outline: none;
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
